module.exports = __webpack_public_path__ + "roboto-blackitalic-webfont.9ad8733d82538101a042.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-blackitalic-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-blackitalic-webfont.svg
// module chunks = styles